import Guid from "_shared/guids/guid";
import { isSystemMessageSeverity, SystemMessageSeverity } from "notifications/system-notifications/system-message-severity";

export default class SystemNotification {
  public readonly id: Guid;
  public readonly content: string;
  public readonly severity?: SystemMessageSeverity;
  public readonly createdDate?: string;

  public get message(): string {
    const parsed = this.parseContent();
    return parsed.message;
  }

  public get type(): SystemMessageSeverity | undefined {
    const parsed = this.parseContent();
    return this.severity ?? parsed.type;
  }

  public constructor(id: Guid, content: string, severity?: SystemMessageSeverity, createdDate?: string) {
    this.id = id;
    this.content = content;
    this.severity = severity;
    this.createdDate = createdDate;
  }

  private parseContent(): { message: string; type?: SystemMessageSeverity } {
    if (!this.content.includes(":")) {
      return { message: this.content };
    }

    const parts = this.content.split(":");
    const rawType = (parts.at(-1) ?? "").trim().toLowerCase();

    return {
      message: parts.slice(0, -1).join(":"),
      type: isSystemMessageSeverity(rawType) ? rawType : undefined,
    };
  }
}
